import React from 'react';
import gridHeaderTemplates from './gridHeaderTemplates';

const mapCellData = (props) => {
  const thContentClasses = `th-content${props.column.headerCss ? ' ' + props.column.headerCss : ''}`;
  return (
    <th onClick={() => props.onClick(props.columnId)} style={{ width: '0px' }} className="th-base" key={props.column.columnHeader}>
      <div className={thContentClasses} style={{ width: props.column.width }}>
        {props.sortConfig && props.sortConfig.key === props.columnId &&
                    (props.sortConfig.direction === 'ASC' ? '▲' : '▼')}
        {props.column.columnHeader}
      </div>
    </th>
  );
};

const GridHeaderCell = (props) => {
  const Template = props.column.headerTemplate && gridHeaderTemplates[props.column.headerTemplate];
  if (Template) {
    return <Template column={props.column} row={props.row} key={props.column.columnHeader} />;
  }

  return mapCellData(props);
};

export default GridHeaderCell;



// WEBPACK FOOTER //
// ./src/common/core/grid/GridHeaderCell.jsx